/**
 * Окно, в котором второй тост об ошибке не нужен.
 *
 * Одно нажатие может сообщить об отказе дважды. Общий обработчик мутаций (`queryClient`)
 * показывает тост первым, а потом промис `mutateAsync` отклоняется, и `catch` у кнопки добавляет
 * свой: «Что-то пошло не так» поверх «Нет соединения с интернетом». Человек читает это как две
 * разные беды, хотя беда одна.
 *
 * Ходить по ~150 местам с `toaster.create({ type: 'error' })` и расставлять в каждом проверку
 * `wasErrorShownToUser` - та самая россыпь, которую общий обработчик и заводился заменить. Поэтому
 * замок один: обработчик, показав тост, открывает окно, а `toaster` (см. `Toaster.tsx`) не
 * пропускает в нём другие тосты типа `error`. Какое-то из мест всегда выигрывает по времени, и
 * победителем остаётся общий тост - у него единое правило выбора текста.
 *
 * Окно короткое: оно покрывает только продолжение того же нажатия (микрозадачи и перерисовка
 * после отказа), а не следующее действие человека.
 */
export const ERROR_TOAST_GATE_MS = 1500;

let openedAt = Number.NEGATIVE_INFINITY;

/** Общий тост об ошибке только что показан: остальные тосты ошибок в ближайшее время лишние. */
export const openErrorToastGate = () => {
  openedAt = Date.now();
};

export const isErrorToastGateOpen = () => Date.now() - openedAt < ERROR_TOAST_GATE_MS;

/** Для тестов: окно не должно переживать тест. */
export const resetErrorToastGateForTests = () => {
  openedAt = Number.NEGATIVE_INFINITY;
};
